<div class="page">
	<header class="page-header">
		<div></div>
	</header>

	<nav class="page-nav navbar navbar-dark bg-primary">
		@if (this.surveyService.getHasScreening()) {
		<span class="navbar-brand m-auto">{{ "HealthSurvey" | translate }}</span>}
		@if ( !this.surveyService.getHasScreening() &&
		this.surveyService.getHasAPV() ) {<span class="navbar-brand m-auto"
			>{{ "HealthSurveyAPV" | translate }}</span
		>}
	</nav>

	<div class="page-menu-left"></div>
	<div class="page-menu-right"></div>

	<div class="page-content">
		@if ( !this.surveyService.getHasAPV() && !enableNext && !ResponseLocked ) {
		<p
			[innerHtml]="'GroupDescriptionHealthProgress' | translate"
			class="mb-3 text-center"
		></p>
		} @if ( this.surveyService.getHasAPV() && !enableNext && !ResponseLocked ) {
		<p
			[innerHtml]="'GroupDescriptionHealthProgress_APV' | translate"
			class="mb-3 text-center"
		></p>
		} @if ( this.surveyService.getHasHealthCheck() &&
		!this.companyservice.getHasActiveHealthProgressFeature() && !enableNext &&
		!ResponseLocked ) {
		<div class="text-center mb-5 mt-4" role="alert">
			<!--<h5 class="text-danger mb-n1">{{'HealthCheckCloseBrowser' | translate}}</h5>-->
			<button
				class="btn btn-primary btn-circle mt-3"
				(click)="lockSurveyUserReponses()"
			>
				{{ "End_Finish_Button" | translate }}
			</button>
		</div>
		} @if ( this.surveyService.getHasHealthCheck() &&
		!this.companyservice.getHasActiveHealthProgressFeature() && !enableNext &&
		ResponseLocked ) {
		<div class="text-center">
			@if (!this.userdataService.hasBooking) {
			<h5
				class="mt-5"
				[innerHtml]="'HealthCheck_End_ThanksFinished' | translate"
			></h5>
			} @if (this.userdataService.hasBooking) {
			<h5
				class="mt-5"
				[innerHtml]="'HealthCheck_End_ThanksFinished_Booking' | translate"
			></h5>
			} @if (this.userdataService.hasBooking) {
			<a class="btn btn-primary btn-circle text-white mt-3" routerLink="/home">
				{{ "Nav_Home" | translate }}
			</a>
			}
		</div>
		} @if ( this.surveyService.getHasHealthCheck() &&
		this.companyservice.getHasActiveHealthProgressFeature() && !enableNext ) {
		<div class="alert alert-danger text-center mb-5" role="alert">
			<h5 class="text-danger mb-n1">
				{{ "HealthProgressCloseBrowser" | translate }}
			</h5>
		</div>
		} @if (this.surveyService.getHasHealthCheck() && enableNext) {
		<div class="mt-5">
			<p>{{ "HealthCheckCalibratedText" | translate }}</p>
			<p>{{ "HealthCheckCalibratedQuestion" | translate }}</p>
			<div class="mb-3 d-flex flex-column text-start">
				<div class="form-check form-radio" style="width: 50px">
					<input
						type="radio"
						class="form-check-input"
						id="calibratedequipmentyes"
						(click)="setCalibratedStatus()"
						name="calibratedEquipment"
						value="true"
					>
					<label class="form-check-label" for="calibratedequipmentyes">
						{{ "Btn_Yes" | translate }}
					</label>
				</div>
				<div class="form-check form-radio" style="width: 50px">
					<input
						type="radio"
						class="form-check-input"
						id="calibratedequipmentno"
						(click)="setCalibratedStatus()"
						name="calibratedEquipment"
						value="false"
					>
					<label class="form-check-label" for="calibratedequipmentno">
						{{ "Btn_No" | translate }}
					</label>
				</div>
			</div>
		</div>
		}

		<div class="d-flex justify-content-center mt-auto">
			<div class="mx-3" [hidden]="ResponseLocked">
				<app-back-button (clicked)="back()" />
			</div>
			@if (enableNext || TestMode) {
			<div class="mx-3" [hidden]="nextQuestionNumber === undefined">
				<button class="btn btn-sm btn-grey btn-circle" (click)="next()">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="3"
						stroke-linecap="round"
						stroke-linejoin="round"
						class="feather feather-chevron-right"
					>
						<polyline points="9 18 15 12 9 6"></polyline>
					</svg>
				</button>
				<span class="btn-circle-text">{{ "Question_Next" | translate }}</span>
			</div>
			}
		</div>
	</div>

	<footer class="page-footer d-md-none">
		<div class="logo negated"></div>
	</footer>
</div>
